 import Babbon from '../assets/baboon.jpg'
 import Giraffe from  '../assets/giraffe2.jpg'
 import NewLion from '../assets/NewLion.jpg'
 import Crocodile from '../assets/crocodile.jpg'
 import Lioness from '../assets/lioness.jpg'
 import Hyena from  '../assets/hyena.jpg'
 import Eland from '../assets/eland.jpg'
 import Cobra from '../assets/cobra.jpg'
 import Aligator from '../assets/aligator.jpg'
 import Amiatina from '../assets/newanimal.jpg'
 import Mallarduck from '../assets/mallardduck.jpg'
 import Python from '../assets/python.jpg'
 import Turtle from '../assets/turtle.jpg'
 import Spurwingedgoose from '../assets/spurwingedgoose.jpg'
 import Whitegeese from '../assets/whitegeese.jpg'
 import CommonJackal from '../assets/commonJackil.jpg'
 import Anaconda from  '../assets/Anaconda.jpg'
import Giraffe3 from '../assets/girrafe3.jpg'

 const  Data = [
    {
        id: 1,
        src:Babbon,
        alt:'babbon',
        name:'Baboon',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Baboon',
        scientific:'Scientific Name',
        sanswer:'Papio (Genus)',
        type:'Type',
        tanswer:'Mammal',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Omnivorous',
        geo:'Geographical Range',
        ganswer:'range extends from Chad in the north to South Africa in the south,and from Niger in the west to Somalia in the east ',
        lifespan:'Life Span',
        lanswer:'20-30 years',
        offspring:'Offspring',
        oanswer:'1 ',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Baboons are also known for their intelligence and problem-solving abilities.',
        aboutBehaviour:' Baboons are highly social animals and live in hierarchical troops ranging from a few individuals to large groups of up to several hundred. Troops are led by dominant males, and females play important roles in maintaining social structure. They have complex social interactions, communicate through various vocalizations and body language, and engage in grooming behaviors to establish and strengthen social bonds. ',
        about:'Baboons are primates known for their distinctive appearance and complex social behaviors. Baboons are medium to large-sized primates, with males being larger than females. They can range in size from about 50 to 120 centimeters (20 to 47 inches) in length, excluding the tail. The tail length can add an additional 30 to 90 centimeters (12 to 35 inches). Baboons are found in various habitats across Africa and parts of Arabia. They can inhabit a range of environments, including savannas, open woodlands, and rocky regions.  Baboons are omnivorous and have a diverse diet. They primarily feed on a combination of fruits, seeds, leaves, grasses, roots, insects, small vertebrates, and occasionally even other primates. Their diet can vary depending on the availability of food in their environment.'
       
    },
    {
        id: 2,
        src:Giraffe,
        src2:Giraffe3,
        alt:'giraffe',
        name:'Giraffe',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Giraffa',
        scientific:'Scientific Name',
        sanswer:'Girrafa Camelopardalis',
        type:'Type',
        tanswer:'Mammalia',
        status:'Status',
        ssanswer:'Vulnerable',
        diet:'Diet',
        danswer:'Herbivores',
        geo:'Geographical Range',
        ganswer:'range extends from Chad in the north to South Africa in the south,and from Niger in the west to Somalia in the east ',
        lifespan:'Life Span',
        lanswer:'25 years',
        offspring:'Offspring',
        oanswer:'1 calf',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'They can grow up to 5.5 meters.Even new-born giraffes are taller than most humans.',
        aboutBehaviour:'The giraffe spend most of the day and part of the night feeding, especially the early morning and late afternoon. In the summer when food is abundant, the giraffe have more time during the day to chew their cud and lie down. ',
        about:'The giraffe is a large African hoofed mammal belonging to the genus Giraffa. It is the tallest living terrestrial animal and the largest ruminant on Earth. Traditionally, giraffes were thought to be one species, Giraffa camelopardalis, with nine subspecies. Most recently, researchers proposed dividing them into up to eight extant species due to new research into their mitochondrial and nuclear DNA, as well as morphological measurements. Seven other extinct species of Giraffa are known from the fossil record.The giraffes chief distinguishing characteristics are its extremely long neck and legs, its horn-like ossicones, and its spotted coat patterns. It is classified under the family Giraffidae, along with its closest extant relative, the okapi. Its scattered range extends from Chad in the north to South Africa in the south, and from Niger in the west to Somalia in the east.'

        

    },   
    {
        id: 3,
        src:NewLion,
        alt:'lion',
        name:'Lion',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Panthera leo leo',
        scientific:'Scientific Name',
        sanswer:'Panthera leo',
        type:'Type',
        tanswer:'Mammal',
        status:'Status',
        ssanswer:'Vulnerable',
        diet:'Diet',
        danswer:'Carnivores',
        geo:'Geographical Range',
        ganswer:'Lions inhabit a wide range of habitats, from open plains to thick brush and dry thorn forest',
        lifespan:'Life Span',
        lanswer:'15-16 years',
        offspring:'Offspring',
        oanswer:'3 calves',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'They can grow up to 5.5 meters.Even new-born giraffes are taller than most humans.',
        aboutBehaviour:'Lions are highly territorial and occupy the same area for generations.  ',
        about:'The lion (Panthera leo) is a large cat of the genus Panthera native to Africa and India. It has a muscular, broad-chested body; short, rounded head; round ears; and a hairy tuft at the end of its tail. It is sexually dimorphic; adult male lions are larger than females and have a prominent mane. It is a social species, forming groups called prides. A lion pride consists of a few adult males, related females, and cubs. Groups of female lions usually hunt together, preying mostly on large ungulates. The lion is an apex and keystone predator although some lions scavenge when opportunities occur and have been known to hunt humans, lions typically do not actively seek out and prey on humans.'

    },
    {
        id: 4, 
        src:Crocodile,
        alt:'crocodile',
        name:'Crocodile',
         description:'Animal Details',
        commonname:'Common Name',
        answer:'Nile crocodile',
        scientific:'Scientific Name',
        sanswer:'Crocodylidae',
        type:'Type',
        tanswer:'Reptiles',
        status:'Status',
        ssanswer:'Threatened.',
        diet:'Diet',
        danswer:'Carnivores',
        geo:'Geographical Range',
        ganswer:'Africa, Asia, and Australia.s',
        lifespan:'Life Span',
        lanswer:'70-50 years',
        offspring:'Offspring',
        oanswer:'30-60',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Nile crocodiles are capable of lifting their bodies off the ground and moving in a more upright position using their powerful hind limbs. ',
        aboutBehaviour:'Nile crocodiles are largely solitary creatures, but they can be found in groups called basks or floats during specific activities like nesting or basking. They are territorial and fiercely defend their territory against intruders, including other crocodiles. They are also known for their ability to remain motionless for extended periods, a behavior called "belly-crawling," which helps them approach prey undetected.',
        about:'The Nile crocodile (Crocodylus niloticus) is one of the largest and most well-known crocodile species in the world. Found throughout sub-Saharan Africa, this formidable reptile has captured the fascination and awe of humans for centuries. Size and Appearance of Nile crocodiles are large reptiles, with adult males reaching lengths of up to 16 to 20 feet (4.8 to 6 meters) and weighing around 1,500 pounds (680 kilograms). Females are slightly smaller, typically measuring around 9 to 13 feet (2.7 to 4 meters). They have a robust body, a broad snout, and powerful jaws lined with sharp teeth. Habitat these crocodiles inhabit a range of aquatic environments, including rivers, lakes, swamps, and marshes. They prefer slow-moving or stagnant water bodies with access to basking spots and suitable nesting areas.'

    },
    {
        id: 5,
        src:Lioness,
        alt:'lioness',
        name:'Lioness'
    },
    {
        id: 6,
        src:Hyena,
        alt:'hyena',
        name:'Hyena',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Spotted hyena.',
        scientific:'Scientific Name',
        sanswer:'Crocuta crocuta',
        type:'Type',
        tanswer:'Mammals',
        status:'Status',
        ssanswer:'Least Concern.',
        diet:'Diet',
        danswer:'Carnivores',
        geo:'Geographical Range',
        ganswer:'Spotted hyenas are found in sub-Saharan Africa.',
        lifespan:'Life Span',
        lanswer:'10-20 years',
        offspring:'Offspring',
        oanswer:'1- 4 cubes',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:' Females are generally larger and more dominant than males. ',
        aboutBehaviour:'Hyenas are social animals and live in hierarchical groups called clans. A clan can consist of up to 80 individuals led by a dominant female called the matriarch. They communicate through a range of vocalizations, including the famous "laughing" sound, which is often associated with their presence.',
        about:'The spotted hyena (Crocuta crocuta) is a large and powerful carnivore found in sub-Saharan Africa.Spotted hyenas have a sturdy build with a sloping back, long front legs, and shorter hind legs. They have a sandy or yellowish-brown coat covered in distinct dark spots, giving them their name. Adult spotted hyenas are typically around 110-190 kg (240-420 lbs) in weight, with males being slightly smaller than females. They stand about 70-90 cm (28-35 inches) tall at the shoulder. Spotted hyenas inhabit a wide range of habitats, including savannas, grasslands, woodlands, and even mountainous regions. They have adapted to various ecosystems across their range.Spotted hyenas live in large social groups called clans, which can comprise 40-80 individuals. They have a complex social hierarchy, with females being dominant over males '

    },
    {
        id: 7,
        src:Eland,
        alt:'eland',
        name:'Common Eland',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'eland',
        scientific:'Scientific Name',
        sanswer:'Taurotragus oryx.',
        type:'Type',
        tanswer:'Mammals',
        status:'Status',
        ssanswer:'Least Concern.',
        diet:'Diet',
        danswer:'Carnivores',
        geo:'Geographical Range',
        ganswer:'Spotted hyenas are found in sub-Saharan Africa.',
        lifespan:'Life Span',
        lanswer:'15-20 years',
        offspring:'Offspring',
        oanswer:'1- 4 cubes',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'It is the second-largest antelope species in the world. ',
        aboutBehaviour:'Common elands are primarily diurnal and are known for their social behavior. They live in herds composed of females, calves, and young males, while adult males often form bachelor groups or may be solitary.',
        about:'The common eland (Taurotragus oryx) is a large antelope species found in various parts of Africa. The common eland is the second-largest antelope species, surpassed only by the African bush elephant. Adult males can reach a shoulder height of around 1.6 to 1.9 meters (5.2 to 6.2 feet) and weigh between 400 to 1,000 kilograms (880 to 2,200 pounds). Females are slightly smaller than males. Common elands have a robust build with long, twisted horns. Both males and females have horns, although those of males tend to be larger and more impressive. They have a reddish-brown or tawny coat with vertical white stripes on their sides. The common eland is found in various habitats across Africa, including savannas, woodlands, grasslands, and semi-deserts. They are most abundant in southern and eastern Africa.'

    },
    {
        id: 8,
        src:Cobra,
        alt:'cobra',
        name:'Cobra',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Cobra',
        scientific:'Scientific Name',
        sanswer:'Naja naja',
        type:'Type',
        tanswer:'Reptiles',
        status:'Status',
        ssanswer:'Vulnerable',
        diet:'Diet',
        danswer:'Carnivorous ',
        geo:'Geographical Range',
        ganswer:'They are distributed across Africa, parts of the Middle East, and some species in Asia.',
        lifespan:'Life Span',
        lanswer:'10-20 years',
        offspring:'Offspring',
        oanswer:'10-20 hatchlings.',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'One unique feature of cobras is their ability to expand the skin on their necks to form a hood',
        aboutBehaviour:' Cobras are generally solitary animals but may come together during mating seasons. They are known for their defensive behavior, often raising their hoods and hissing loudly to deter potential threats. Some species, like the spitting cobras, can also eject venom accurately towards the eyes of their attackers.',
        about:'The cobra is a venomous snake belonging to the family Elapidae, Cobras are known for their potent venom, which they deliver through their fangs when biting prey or defending themselves. The venom is primarily used to immobilize and kill their prey.Cobras are a diverse group of snakes, with various species found across Africa, Asia, and parts of the Middle East. Some well-known cobra species include the Indian cobra, Egyptian cobra, king cobra, and black-necked cobra, Cobras are characterized by their long, slender bodies and distinctive hoods. When threatened or alarmed, they can spread the skin on their necks to create a hood-like shape, making them appear larger and more intimidating.Cobras exhibit a range of sizes, with some species growing only a few feet long, while others, like the king cobra, can reach lengths of up to 5.5 meters (18 feet), making it the longest venomous snake in the world.'

    },
    {
        id: 9,
        src:Aligator,
        alt:'Alligator',
        name:'Alligator',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'alligator',
        scientific:'Scientific Name',
        sanswer:'Alligator mississippiensis',
        type:'Type',
        tanswer:'Reptiles',
        status:'Status',
        ssanswer:'Least Concern.',
        diet:'Diet',
        danswer:'Carnivorous',
        geo:'Geographical Range',
        ganswer:'is native to the southeastern United States.',
        lifespan:'Life Span',
        lanswer:'30-50 years',
        offspring:'Offspring',
        oanswer:'20-50',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'They possess specialized lungs and a unique respiratory system that allows them to control their position in the water column.  ',
        aboutBehaviour:'Alligators are known for their ability to swim and dive. They have powerful tails that propel them through the water and can reach surprising speeds when necessary. Alligators are also capable of remaining submerged for extended periods, using their nostrils to breathe while the rest of their body remains hidden.',
        about:'The alligator is a large reptile belonging to the family Alligatoridae, which includes two living species: the American alligator (Alligator mississippiensis) and the Chinese alligator (Alligator sinensis).Alligators have a stocky, semi-aquatic build with a broad snout, powerful jaws, and a muscular tail. They are covered in armored scales, known as scutes, which provide protection. Alligators are among the largest reptiles in the world. The American alligator is generally larger, with males reaching an average length of 3.4 to 4.6 meters (11 to 15 feet) and weighing around 227 to 454 kilograms (500 to 1,000 pounds). Females are slightly smaller, typically measuring around 2.6 to 3 meters (8 to 10 feet) in length. Chinese alligators are smaller, with males reaching about 1.5 to 2.1 meters (5 to 7 feet) in length.'

    },
    {
        id: 10,
        src:Amiatina,
        alt:'amiatina',
        name:'Amiatina Donkey',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'Amiatina',
        scientific:'Scientific Name',
        sanswer:' Equus africanus asinus.',
        type:'Type',
        tanswer:'Mammal',
        status:'Status',
        ssanswer:'Endangered',
        diet:'Diet',
        danswer:'Herbivores',
        geo:'Geographical Range',
        ganswer:' primarily found in the Amiata region of Tuscany, Italy',
        lifespan:'Life Span',
        lanswer:'25-35 years',
        offspring:'Offspring',
        oanswer:'1 foal',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'The Amiatina Donkey serves as a symbol of the regions heritage and a connection to its agricultural past.',
        aboutBehaviour:'Donkeys are social animals that typically form strong bonds with other donkeys or companion animals.',
        about:'The Amiatina Donkey, also known as the Amiatina breed or the Amiata Donkey, is a specific breed of donkey originating from the Amiata region in Tuscany, Italy. The breed is named after the Monte Amiata, a volcanic mountain in the area.Amiatina Donkeys are known for their strength, hardiness, and adaptability to mountainous terrains. They have a compact and sturdy build, with a medium-sized head, long ears, and a short, dense coat. The coat color of the Amiatina Donkey is usually gray or dark gray, although other colors such as brown or black can also be found.These donkeys were traditionally used for agricultural work, such as carrying loads and pulling carts, in the rugged and hilly areas of Tuscany. Due to mechanization and changes in farming practices, the Amiatina Donkey population declined significantly over the years, and the breed became endangered.Efforts have been made to preserve and protect the Amiatina Donkey breed, and there are now dedicated breeding programs and conservation initiatives in place. The breed is valued for its cultural and historical significance as well as its potential in eco-tourism and animal-assisted therapy programs.The Amiatina Donkey is recognized as a distinct breed and is considered an important part of the agricultural heritage of the Amiata region in Italy'


    },
    {
        id: 11,
        src:Mallarduck,
        alt:'mallarduck',
        name:'Mallarduck',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'Mallard',
        scientific:'Scientific Name',
        sanswer:'Anas platyrhynchos',
        type:'Type',
        tanswer:'Bird',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Omnivorous',
        geo:'Geographical Range',
        ganswer:'Originally native to North America, Europe, and Asia.',
        lifespan:'Life Span',
        lanswer:'5-10 years',
        offspring:'Offspring',
        oanswer:'8 - 13',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Mallards have a high degree of genetic compatibility with other closely related duck species, leading to the formation of hybrid offspring',
        aboutBehaviour:'Mallard Ducks are social birds and often gather in flocks. They are known for their characteristic "quack" call, which is more common in females. They have a strong flight capability and can reach speeds of up to 55 mph (88 km/h).',
        about:'The Mallard Duck (Anas platyrhynchos) is a species of dabbling duck that is native to North America, Europe, and Asia. It is also one of the most recognized and widespread duck species in the world. Male Mallard Ducks have a vibrant plumage with a green head, yellow bill, white collar ring, and a chestnut breast. The rest of their body is grayish with black markings. Females, known as hens, have a more mottled brown plumage for camouflage. Both males and females have a distinct blue speculum (wing patch) bordered by white. Mallard Ducks inhabit a wide range of wetland habitats, including marshes, ponds, lakes, rivers, and coastal areas. They can adapt to both freshwater and saltwater environments.'

    }, {
        id: 12,
        src:Python,
        alt:'python',
        name:'Python',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Python',
        scientific:'Scientific Name',
        sanswer:'Python sebae',
        type:'Type',
        tanswer:'Reptiles',
        status:'Status',
        ssanswer:'vulnerable or endangered.',
        diet:'Diet',
        danswer:'Carnivorous ',
        geo:'Geographical Range',
        ganswer:'Occurs in sub-Saharan Africa, including countries like Nigeria, Cameroon, Congo, Uganda, and Kenya.',
        lifespan:'Life Span',
        lanswer:'20-30 years',
        offspring:'Offspring',
        oanswer:'10-20 hatchlings.',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Pythons have incredibly elastic jaws and highly expandable stomachs, allowing them to swallow prey whole.',
        aboutBehaviour:' The number of offspring produced by Python snakes can vary depending on the species, the size and health of the female, and environmental factors. In general, pythons are known to produce relatively large clutches of eggs compared to other snake species.',
        about:'The Python snake, also known as the Pythonidae family, refers to a group of nonvenomous constrictor snakes. There are several species of pythons, but some of the most well-known include the reticulated python (Python reticulatus), Burmese python (Python bivittatus), and ball python (Python regius).Pythons are among the largest snakes in the world, with some species capable of reaching lengths of over 20 feet (6 meters). The reticulated python holds the record for being the worlds longest snake. Pythons have a robust body, a triangular-shaped head, and smooth scales. They typically have a patterned or mottled appearance, which helps them blend into their surroundings. Colors and patterns vary depending on the species, ranging from earthy tones to vibrant patterns.'

    }, {
        id: 13,
        src:Mallarduck,
        alt:'mallarduck',
        name:'Mallarduck',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'Mallard',
        scientific:'Scientific Name',
        sanswer:'Anas platyrhynchos',
        type:'Type',
        tanswer:'Bird',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Omnivorous',
        geo:'Geographical Range',
        ganswer:'Originally native to North America, Europe, and Asia.',
        lifespan:'Life Span',
        lanswer:'5-10 years',
        offspring:'Offspring',
        oanswer:'8 - 13',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Mallards have a high degree of genetic compatibility with other closely related duck species, leading to the formation of hybrid offspring',
        aboutBehaviour:'Mallard Ducks are social birds and often gather in flocks. They are known for their characteristic "quack" call, which is more common in females. They have a strong flight capability and can reach speeds of up to 55 mph (88 km/h).',
        about:'The Mallard Duck (Anas platyrhynchos) is a species of dabbling duck that is native to North America, Europe, and Asia. It is also one of the most recognized and widespread duck species in the world. Male Mallard Ducks have a vibrant plumage with a green head, yellow bill, white collar ring, and a chestnut breast. The rest of their body is grayish with black markings. Females, known as hens, have a more mottled brown plumage for camouflage. Both males and females have a distinct blue speculum (wing patch) bordered by white. Mallard Ducks inhabit a wide range of wetland habitats, including marshes, ponds, lakes, rivers, and coastal areas. They can adapt to both freshwater and saltwater environments.'

    },
    {
        id: 14,
        src:Turtle,
        alt:'turtle',
        name:'Turtle',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'Mallard',
        scientific:'Scientific Name',
        sanswer:'Anas platyrhynchos',
        type:'Type',
        tanswer:'Reptile',
        status:'Status',
        ssanswer:'stable',
        diet:'Diet',
        danswer:'Omnivorous',
        geo:'Geographical Range',
        ganswer:'Turtles have a diverse geographical range and can be found on every continent except Antarctica.',
        lifespan:'Life Span',
        lanswer:'50 years',
        offspring:'Offspring',
        oanswer:'5 -20',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'The shell, composed of bony plates covered by a layer of keratin, provides a durable and resilient structure for their protection.',
        aboutBehaviour:'Turtles are ectothermic, meaning they rely on external heat sources to regulate their body temperature. Most turtle species are adept swimmers and spend a significant amount of time in water.',
        about:'Turtles are fascinating reptiles that belong to the order Testudines. They are known for their distinct features, such as a protective shell and a slow, methodical way of life.One of the most distinguishing features of turtles is their shell, which consists of a top portion called the carapace and a bottom portion known as the plastron. The shell is composed of bony plates covered by a layer of keratin. It provides protection and serves as a unique adaptation for defense.Turtles are found in a variety of habitats, including freshwater bodies like lakes, rivers, and ponds, as well as in oceans and on land. Different turtle species have specific habitat preferences, ranging from aquatic species that spend most of their time in water to terrestrial species that inhabit forests and grasslands.'

    },
    {
        id: 15,
        src:Spurwingedgoose,
        alt:'spurwingedgoose',
        name:'Spur Winged Goose',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'Spur-winged Goose',
        scientific:'Scientific Name',
        sanswer:' Plectropterus gambensis',
        type:'Type',
        tanswer:'Bird (Waterfowl)',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Herbivorous',
        geo:'Geographical Range',
        ganswer:'The species is native to sub-Saharan Africa.',
        lifespan:'Life Span',
        lanswer:'10-15 years',
        offspring:'Offspring',
        oanswer:'4-7',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'The male of this species has a sharp spur on the bend of the wing, which is absent in the female.',
        aboutBehaviour:'Spur-winged Geese are generally social birds and often form small flocks or pairs. They are known for their loud, honking calls, especially during flight or when disturbed. They are strong flyers and can cover long distances during migration.',
        about:'The Spur-winged Goose (Plectropterus gambensis) is a large waterfowl species native to sub-Saharan Africa. Here are some key characteristics and information about the Spur-winged Goose,Adult Spur-winged Geese can reach a length of around 75-100 cm (30-40 inches) and have a wingspan of approximately 160-180 cm (63-71 inches).Spur-winged Geese are typically found in wetland areas such as swamps, marshes, floodplains, and lakeshores. They prefer habitats with ample vegetation and water.'

    },
    {
        id: 16,
        src:Whitegeese,
        alt:'whitegeese',
        name:'White Geese',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:'White Geese (or Domestic Geese)',
        scientific:'Scientific Name',
        sanswer:'Anser domesticus ',
        type:'Type',
        tanswer:'Bird (Waterfowl)',
        status:'Status',
        ssanswer:'Threatened',
        diet:'Diet',
        danswer:'Herbivorous',
        geo:'Geographical Range',
        ganswer:'They are found worldwide in various countries',
        lifespan:'Life Span',
        lanswer:'10-20 years',
        offspring:'Offspring',
        oanswer:'20-50',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Geese are known for their highly developed social behavior',
        aboutBehaviour:'Domestic geese are social animals and often live in groups or flocks. They have a strong sense of community and can display protective behavior towards their flock mates. Domestic geese can also be trained to some extent and may exhibit territorial behavior.',
        about:'Domestic geese can vary in size depending on the breed. They can range from medium-sized geese, such as the Chinese goose, to larger breeds like the Embden goose or Toulouse goose.Domestic geese are primarily kept in domesticated settings, such as farms, rural areas, or even as backyard pets. They are adaptable and can live in various environments, as long as they have access to water for swimming and grazing areas for feeding. Domestic geese can be found in many countries around the world, where they are raised for various purposes, including meat, eggs, feathers, or as ornamental birds.  '

    },
    {
        id: 17,
        src:CommonJackal,
        alt:'common jackal',
        name:'Common Jackal',
        description:'Animal Details',   
        commonname:'Common Name',
        answer:' Common Jackal or Golden Jackal',
        scientific:'Scientific Name',
        sanswer:'Canis aureus',
        type:'Type',
        tanswer:'Mammal',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Omnivores',
        geo:'Geographical Range',
        ganswer:'Africa, Asia, and southeastern Europe.',
        lifespan:'Life Span',
        lanswer:'8-10    years',
        offspring:'Offspring',
        oanswer:'3 - 6 pups',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'They are highly versatile and can thrive in a wide range of habitats, from deserts to grasslands to forests.',
        aboutBehaviour:' Common jackals are social animals that typically live in family groups consisting of a breeding pair and their offspring from previous years. They communicate using a range of vocalizations, including howls, barks, and yelps. They are primarily nocturnal but can also be active during the day, especially in areas with less human disturbance.',
        about:'The common jackal, also known as the golden jackal, is a species of medium-sized canid native to parts of Africa, Asia, and southeastern Europe. Common jackals are typically about the size of a small to medium-sized dog, with a body length ranging from 70 to 85 cm (27 to 33 inches) and a shoulder height of around 40 cm (16 inches). They weigh between 6 and 14 kg (13 to 31 lbs). Common jackals are adaptable and can be found in various habitats, including forests, grasslands, savannas, scrublands, and even urban areas. Common jackals are opportunistic omnivores. Their diet primarily consists of small mammals, birds, reptiles, insects, fruits, and carrion. They are skilled scavengers and often feed on the remains of larger animal kills.Breeding typically occurs in winter or early spring. The gestation period lasts for about two months, after which the female gives birth to a litter of 3 to 6 pups. The pups are cared for by both parents and remain with the family group for several months before dispersing to find their own territories '

    },{
        id: 18,
        src:Anaconda,
        alt:'Anaconda',
        name:'Anaconda',
        description:'Animal Details',
        commonname:'Common Name',
        answer:'Anaconda',
        scientific:'Scientific Name',
        sanswer:'Eunectes spp.',
        type:'Type',
        tanswer:'Reptile',
        status:'Status',
        ssanswer:'Least Concern',
        diet:'Diet',
        danswer:'Ovoviviparous ',
        geo:'Geographical Range',
        ganswer:'Occurs in sub-Saharan Africa, including countries like Nigeria, Cameroon, Congo, Uganda, and Kenya Argentina, southeastern Brazil, Uruguay, and eastern Paraguay.',
        lifespan:'Life Span',
        lanswer:'20-30 years',
        offspring:'Offspring',
        oanswer:'20-40 ',
        meet:'Meet The',
        span1:'Animal',
        their:'Their',
        behaviour:'Behaviour',
        know:'Did You Know',
        aboutKnow:'Anacondas use their muscular bodies, flattened tails, and ability to hold their breath to navigate through water with ease.',
        aboutBehaviour:'Anacondas are solitary and mostly nocturnal creatures. They spend much of their time in or near water, using their excellent swimming and diving abilities to navigate their environment. They are excellent swimmers and can move swiftly through the water.',
        about:'The anaconda is a large snake species found in the tropical rainforests of South America.Anacondas are among the largest snakes in the world. The green anaconda (Eunectes murinus) is the largest and can reach lengths of up to 5.5 meters (18 feet) and weigh over 200 kilograms (440 pounds). The other anaconda species are generally smaller.Anacondas are primarily found in the dense tropical rainforests, swamps, marshes, and rivers of South America, including the Amazon Basin and the Orinoco Basin. They are highly adapted to an aquatic lifestyle and are often found near water bodies. Anacondas are powerful constrictor snakes that primarily prey on a variety of aquatic and semi-aquatic animals. Their diet includes fish, amphibians, reptiles, birds, and mammals. Anacondas are known to ambush and suffocate their prey by coiling their muscular bodies around them. '

    }
];

export default Data;